import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import Card from '../Card/Card';
import shieldIcon from '../../assets/images/shield-icon.svg';
import moneyIcon from '../../assets/images/money-usd.svg';
import { isTaxable } from '../../flows/shared/utils';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const MoneyMarketCard = () => {
  const { next, appState } = useContext(FlowContext);
  const { store } = appState;
  const accountType = store?.accountType;
  return isTaxable(accountType) ? (
    <Card
      icon={shieldIcon}
      title="Open my account with a Money Market Fund"
      subtitle="Money Market funds seek to maintain a stable share price and can be used to save for short-term goals or to reserve for a future investment."
      buttonText="View Money Market Fund Options"
      buttonFunction={next('money-market')}
      buttonID={generateGeneralTestID('Card', 'MoneyMarketButton')}
      cardID={generateGeneralTestID('Card', 'MoneyMarketCard')}
    />
  ) : (
    <Card
      icon={moneyIcon}
      title="Select or Choose a Money Market Fund"
      subtitle="Money Market Funds seek to maintain a stable share price and can be used to save for short-term goals or until you're ready to make a long-term investment selection."
      buttonText="Select a Money Market Fund"
      buttonFunction={next('money-market')}
      buttonID={generateGeneralTestID('Card', 'MoneyMarketButton')}
      cardID={generateGeneralTestID('Card', 'MoneyMarketCard')}
    />
  );
};

export default MoneyMarketCard;
